import { MODAL_ROOT_ID } from "../constants";

/**
 * Připraví potřebné věci pro správný běh Reactu.
 */
export const configureReact = () => {
    createModalRoot();
};

/**
 * Vytvoří kontejner pro renderování modálních oken a vloží ho za posledního potomka `<body>`.
 * Pokud element s daným id již existuje, nic nedělá.
 */
const createModalRoot = () => {
    if (!document.getElementById(MODAL_ROOT_ID)) {
        const modalRoot = document.createElement("div");
        modalRoot.id = MODAL_ROOT_ID;
        // Používá se `prepend` kvůli ztrátě focusu v Chrome při ovládání pomocí klávesnice.
        document.body.prepend(modalRoot);
    }
};
